module.exports = __webpack_public_path__ + "img/credit-card-02.5b27bf0e.svg";